import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./locales/en.json";
import ar from "./locales/ar.json";

export type AppLanguage = "en" | "ar";

const RTL_LANGUAGES: ReadonlySet<AppLanguage> = new Set<AppLanguage>(["ar"]);
const SUPPORTED_LANGUAGES: ReadonlySet<AppLanguage> = new Set<AppLanguage>(["en", "ar"]);

export const LANGUAGE: AppLanguage = resolveInitialLanguage();

export function isRtl(lang: AppLanguage) {
    return RTL_LANGUAGES.has(lang);
}

function resolveInitialLanguage(): AppLanguage {
    if (typeof window === "undefined") {
        return "ar";
    }

    const urlLanguage = new URLSearchParams(window.location.search).get("lang");
    if (isAppLanguage(urlLanguage)) {
        window.localStorage.setItem("app-language", urlLanguage);
        return urlLanguage;
    }

    const storedLanguage = window.localStorage.getItem("app-language");
    if (isAppLanguage(storedLanguage)) {
        return storedLanguage;
    }

    return "ar";
}

function isAppLanguage(value: string | null): value is AppLanguage {
    return value !== null && SUPPORTED_LANGUAGES.has(value as AppLanguage);
}

i18n.use(initReactI18next).init({
    resources: {
        en: { translation: en },
        ar: { translation: ar },
    },
    lng: LANGUAGE,
    fallbackLng: "en",
    interpolation: { escapeValue: false },
});

if (typeof document !== "undefined") {
    const root = document.documentElement;
    root.lang = LANGUAGE;
    root.dir = isRtl(LANGUAGE) ? "rtl" : "ltr";
    document.title = i18n.t("app.documentTitle");
}

export default i18n;
